import styled from 'styled-components';
import { Link } from "react-router-dom";

export const MypageSetInner = styled.div`
    min-height: 100vh;
    height: auto;
    padding : calc(100vw*(51/375)) 0 calc(100vw*(60/375)) 0;
` 
export const Arrowright = styled.em` 
    display:block;
    width: calc(100vw*(8/375));
    height: calc(100vw*(13/375));
    object-fit: contain;
    margin-left : calc(100vw*(10.7/375));
`
export const Setlistinner = styled.ul`
    & > li:last-child {
    }
`
export const Setlist = styled.li`
    height : calc(100vw*(50.5/375));
    border-bottom: solid  calc(100vw*(1/375)) #d8d8d8;
    padding : 0 calc(100vw*(17/375)) 0;
    background :#fff;
`
export const SetlistLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width:100%;
`
export const Setlistname = styled.span`
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    color: #1d1d1d;
`
export const Setlistcont = styled.span`
    display: flex;
    align-items: center;
`
export const Setlistdata = styled.em`
    font-size: calc(100vw*(11/375));
    font-weight: 500;
    color: #989898;
`
export const Switchinput = styled.input`
    display:none;

    &:checked + label {background-color: #ffcf19;}
    &:checked + label::before {transform: translate(calc(100vw*(16/375)),-50%);}
`
export const Switchlabel = styled.label`
    position: relative;
    padding: 0 calc(100vw*(9/375));
    display: flex;
    justify-content: space-between;
    width: calc(100vw*(34/375));
    height: calc(100vw*(14/375));
    border-radius: calc(100vw*(20/375));
    background-color:   rgb(116, 116, 116,0.4);
    font-size: calc(100vw*(12/375));
    font-weight: 500;
    letter-spacing: -0.29px;
    color: #4e4e4e;

    &::before {
        content: '';
        display:block;
        width:  calc(100vw*(20/375));
        height:  calc(100vw*(20/375));
        box-shadow: 0  calc(100vw*(1/375))  calc(100vw*(3/375)) 0 rgba(0, 0, 0, 0.21);
        background-color: #ffffff;
        position: absolute;
        left: calc(100vw*(-1/375));
        top: 50%;
        transform: translateY(-50%);    
        transition : all .4s ease;
        border-radius: calc(100vw*(13/375));
        color: #4e4e4e;
        line-height: calc(100vw*(26/375));
        text-align: center;

    }
`